import { useUnit } from 'effector-react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Dialog, DialogContent } from '../../shared/ui';
import { $request, closed } from './model';

/** Confirmation for destructive or irreversible actions (cancel, skip, undo). */
export function ConfirmDialog() {
  const { t } = useTranslation();
  const [request, close] = useUnit([$request, closed]);
  const [busy, setBusy] = useState(false);
  return (
    <Dialog
      open={request !== null}
      onOpenChange={(open) => {
        if (!open) close();
      }}
    >
      {request && (
        <DialogContent
          title={request.title}
          description={request.body}
          closeLabel={t('common.close')}
          footer={
            <>
              <Button onClick={close}>{t('common.cancel')}</Button>
              <Button
                variant={request.danger === true ? 'danger' : 'primary'}
                disabled={busy}
                onClick={() => {
                  setBusy(true);
                  request
                    .onConfirm()
                    .then(() => {
                      close();
                    })
                    .catch(() => undefined)
                    .finally(() => {
                      setBusy(false);
                    });
                }}
              >
                {request.confirmLabel}
              </Button>
            </>
          }
        />
      )}
    </Dialog>
  );
}
